module.exports = __webpack_public_path__ + "img/connection-left-1.9c3ac9e2.png";